if (!customElements.get("m-product-inventory")) {
  class productInventory extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        inventoryQuantity: ".m-product-inventory__quantity",
        inventoryStatus: ".m-product-inventory__status",
        inventoryMessage: ".m-product-inventory__message",
        indicatorBar: ".m-product-inventory__indicator-bar",
      };
      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      this.productId = this.dataset.productId;
      this.inventoryVisibility = this.dataset.inventoryVisibility;
      this.hideStockBackordered = this.dataset.hideStockBackordered === "true";

      this.handleVariantChange();

      this.updateInventoryStatus(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === "true",
        this.dataset.inventoryPolicy
      );
    }

    handleVariantChange() {
      window.MinimogEvents.subscribe(
        `${this.productId}__VARIANT_CHANGE`,
        (variant) => {
          if (variant) {
            const inventoryData = JSON.parse(
              this.querySelector('[type="application/json"]').textContent
            );
            const vObj = inventoryData.find((v) => v.id === variant.id);
            this.updateInventoryStatus(
              parseInt(vObj.inventory_quantity, 10),
              vObj.available,
              vObj.inventory_policy
            );
          } else {
            this.updateInventoryStatus(0, false);
          }
        }
      );
    }

    updateInventoryStatus(count, available, inventoryPolicy) {
      let status;
      let show = false;

      // 1) Nuevo estado: “last” cuando quede exactamente 1 unidad
      if (count === 1) {
        status = "last";

      // 2) Sin stock o políticas especiales
      } else if (count <= 0) {
        if (inventoryPolicy === "continue") {
          status = "backordered";
        } else if (available) {
          status = "instock";
        } else {
          status = "outofstock";
        }

      // 3) Stock bajo
      } else if (count <= this.dataset.inventoryThreshold) {
        status = "low";

      // 4) Stock normal
      } else {
        status = "normal";
      }

      this.setAttribute("data-status", status);

      // Decide si mostrar el bloque de inventario
      if (this.inventoryVisibility === "always") {
        show = true;
        if (status === "backordered" && this.hideStockBackordered) {
          show = false;
        }
      } else {
        if (status === "low" || status === "last") {
          show = true;
        }
      }

      if (show) {
        this.classList.remove("m:hidden");
        const txts = this.getInventoryText()[status];
        this.domNodes.inventoryMessage.innerHTML = txts.message;

        // Mostrar u ocultar el conteo según configuración
        if (txts.show_count) {
          if (txts.text_html) {
            const html = txts.text_html.replace("{{ quantity }}", count);
            this.domNodes.inventoryStatus.classList.remove("m:hidden");
            this.domNodes.inventoryStatus.innerHTML = html;
          } else {
            this.domNodes.inventoryStatus.classList.add("m:hidden");
            this.domNodes.inventoryStatus.innerHTML = "";
          }
        } else {
          if (txts.text) {
            this.domNodes.inventoryStatus.classList.remove("m:hidden");
            this.domNodes.inventoryStatus.innerHTML = txts.text;
          } else {
            this.domNodes.inventoryStatus.classList.add("m:hidden");
            this.domNodes.inventoryStatus.innerHTML = "";
          }
        }

        this.handleIndicatorBar(status, count);
      } else {
        this.classList.add("m:hidden");
      }
    }

    handleIndicatorBar(status, count) {
      if (!this.domNodes.indicatorBar) return;

      const total = parseInt(this.dataset.total, 10);
      let width;

      if (["backordered", "outofstock"].includes(status)) {
        width = 0;
      } else if (status === "last") {
        // Mismo ancho que si count=1 sobre total, pero podrías estilizar distinto en CSS
        width = Math.max(((count / total) * 100).toFixed(1), 5);
      } else if (status === "instock" || count >= total) {
        width = 100;
      } else {
        width = Math.max(((count / total) * 100).toFixed(1), 5);
      }

      this.domNodes.indicatorBar.querySelector("span").style.width = `${width}%`;
    }

    getInventoryText() {
      const {
        inStock,
        outOfStock,
        lowStock,
        inventoryQuantityHtml,
        inventoryLowQuantityHtml,
      } = window.MinimogStrings;
      const show_count = this.dataset.showInventoryCount;

      return {
        normal: {
          text: inStock,
          text_html: inventoryQuantityHtml,
          message: this.dataset.normalText,
          show_count: show_count === "always",
        },
        instock: {
          text: inStock,
          message: this.dataset.normalText,
          show_count: false,
        },
        low: {
          text: lowStock,
          text_html: inventoryLowQuantityHtml,
          message: this.dataset.lowText,
          show_count: show_count !== "never",
        },
        outofstock: {
          text: outOfStock,
          message: this.dataset.outofstockText,
          show_count: false,
        },
        backordered: {
          text: "",
          message: this.dataset.backorderedText,
          show_count: false,
        },
        // Nuevo estado “last”
        last: {
          text: "Último en stock",
          message:
            this.dataset.lastText || "¡Queda sólo una unidad en inventario!",
          show_count: false,
        },
      };
    }
  }

  customElements.define("m-product-inventory", productInventory);
}
